export default __webpack_public_path__ + "static/media/project-go-ceres.0a692617.png";